import { Expose } from 'class-transformer';
import { DeviceSettingsType } from './device-settings-type';
import { getSettingsClassType } from '../util/data-parser';
import { TransformDate } from 'src/app/common/util/transform-date';
import { generateRandomHash } from 'src/app/shared/util/data-util';
import { DeviceType } from './device-type';

export abstract class DeviceSetting {

    @Expose({ name: 'machine_id' })
    machineId: string;

    @Expose({ name: 'side_number' })
    sideNumber: string;

    @Expose({ name: 'uuid' })
    hash: string;

    @Expose({ name: 'timestamp' })
    @TransformDate()
    settingAt: Date;

    @Expose({ name: 'setting_type' })
    settingType: DeviceSettingsType;

    @Expose()
    address?: string;

    @Expose()
    addresses?: string[];

    @Expose({name: 'device_type'})
    deviceType?: DeviceType;

    setSettingValue(_value: Record<string, any>): void { };

    getSettingValue(): Record<string, any> {return;};
}

export function createDeviceSetting<T extends DeviceSetting>(
    machineId: string, sideNumber: string, settingValue: Record<string, any>, settingType: DeviceSettingsType, deviceType: DeviceType,
    address?: string, addresses?: string[]): T {
    const setting: T = Object.assign(new (getSettingsClassType(settingType))(), {
        machineId,
        sideNumber,
        settingAt: new Date(),
        settingType,
        hash: generateRandomHash(),
        address,
        addresses,
        deviceType
    });
    setting.setSettingValue(settingValue);
    return setting;
}
